<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-form layout="inline">
        <a-form-item :label="$tt('产品型号')">
          <a-select v-model="query.productModel" allow-clear style="width: 130px">
            <a-select-option value="SS5K">SS5K</a-select-option>
            <a-select-option value="EX06">EX06</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$tt('序列号')"><a-input v-model="query.serialNumber" allow-clear /></a-form-item>
        <a-form-item :label="$tt('上传人')"><a-input v-model="query.uploader" allow-clear @pressEnter="search" /></a-form-item>
        <a-button type="primary" @click="search">{{ $tt('查询') }}</a-button>
        <a-button style="margin-left: 8px" @click="open()">{{ $tt('新增') }}</a-button>
      </a-form>
      <a-table
        style="margin-top: 16px"
        row-key="id"
        :columns="columns"
        :data-source="rows"
        :loading="loading"
        :pagination="false">
        <template slot="rawData" slot-scope="text"><exception-data :raw-data="text" /></template>
        <template slot="actions" slot-scope="text, record">
          <a @click="open(record)">{{ $tt('编辑') }}</a><a-divider type="vertical" />
          <a-popconfirm :title="$tt('确定删除这条异常数据？')" @confirm="remove(record)"><a>{{ $tt('删除') }}</a></a-popconfirm>
        </template>
      </a-table>
      <a-pagination
        style="margin-top: 16px"
        :current="query.pageNum"
        :page-size="query.pageSize"
        :total="total"
        show-size-changer
        @change="changePage"
        @showSizeChange="changeSize" />
      <a-modal
        :title="form.id ? $tt('编辑异常数据') : $tt('新增异常数据')"
        :visible="visible"
        @ok="save"
        @cancel="visible = false">
        <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item :label="$tt('产品型号')">
            <a-select v-model="form.productModel"><a-select-option value="SS5K">SS5K</a-select-option>
              <a-select-option value="EX06">EX06</a-select-option></a-select>
          </a-form-model-item>
          <a-form-model-item :label="$tt('序列号')"><a-input v-model="form.serialNumber" /></a-form-model-item>
          <a-form-model-item :label="$tt('原始数据')"><a-textarea v-model="form.rawData" :rows="5" /></a-form-model-item>
          <a-form-model-item v-if="form.rawData" :label="$tt('解析结果')">
            <exception-data :raw-data="form.rawData" :show-raw="false" />
          </a-form-model-item>
          <a-form-model-item :label="$tt('备注')"><a-input v-model="form.remark" /></a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { translateText } from '@/locales/text'

import { pageDeviceException, addDeviceException, editDeviceException, deleteDeviceException } from '@/api/cio/deviceException'
import ExceptionData from './ExceptionData.vue'

export default {
  name: 'DeviceException',
  components: { ExceptionData },
  data () {
    return {
      loading: false,
visible: false,
rows: [],
total: 0,
      query: { productModel: undefined, serialNumber: '', uploader: '', pageNum: 1, pageSize: 10 },
      form: {},
      columns: [
        { get title () { return translateText('型号') }, dataIndex: 'productModel' },
        { get title () { return translateText('产品序列号') }, dataIndex: 'serialNumber' },
        { get title () { return translateText('异常详情') }, dataIndex: 'rawData', scopedSlots: { customRender: 'rawData' } },
        { get title () { return translateText('备注') }, dataIndex: 'remark' },
        { get title () { return translateText('上传人') }, dataIndex: 'uploader', customRender: text => text || '—' },
        { get title () { return translateText('上传时间') }, dataIndex: 'createTime' },
        { get title () { return translateText('操作') }, scopedSlots: { customRender: 'actions' } }
      ]
    }
  },
  mounted () { this.load() },
  methods: {
    search () { this.query.pageNum = 1; return this.load() },
    async load () {
      this.loading = true
      try {
        const response = await pageDeviceException(this.query)
        this.rows = response.data.records
        this.total = Number(response.data.total)
      } finally { this.loading = false }
    },
    changePage (page) { this.query.pageNum = page; this.load() },
    changeSize (page, size) { this.query.pageNum = page; this.query.pageSize = size; this.load() },
    open (record) { this.form = record ? { ...record } : { productModel: 'SS5K', serialNumber: '', rawData: '', remark: '' }; this.visible = true },
    async save () {
      if (!this.form.serialNumber || !/^(?:[0-9a-fA-F]{2})+$/.test(this.form.rawData)) {
        this.$message.error(translateText('请填写序列号和完整的十六进制原始数据'))
        return
      }
      await (this.form.id ? editDeviceException(this.form) : addDeviceException(this.form))
      this.visible = false
      await this.load()
    },
    async remove (record) { await deleteDeviceException({ id: record.id }); await this.load() }
  }
}
</script>
